// src/App.js
import React, { useEffect, useState } from "react";
import "datatables.net";
import "datatables.net-dt/css/dataTables.dataTables.css"; // Doğru CSS importu
import AdminCollegeDatatable from "./CollegeDatatable";
// import {  getDataWithType } from '../../../lib/studentchecklistview'
import { getAllData } from "../../../lib/collegelistinfo";
import { Link } from "react-router-dom";

const data = [
  [
    "001",
    "Harvard College",
    "Massachusetts",
    ["Option 1", "Option 2", "Option 3"],
    "4.7%",
    "3.9",
    "E: 710-770",
    "Urban, Small City",
    "Medium",
    "D1",
    "$54,002",
    "$18,389",
    "$18,389",
    "$18,389",
    "$18,389",
    "www.harvard.edu/",
    "college.harvard.edu/financial-aid/net-price-calculator",
    true,
  ],
];

function AdminCollegeList() {
  const [collegelistinfo, setCollegeListInfo] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refreshData, setRefreshData] = useState(false);

  async function GetData() {
    const list = await getAllData(setLoading);
    setCollegeListInfo(list);
    console.log("collegalisthere", list);
  }

  useEffect(() => {
    GetData();
  }, [refreshData]);

  return (
    <div className="App">
      <h1 className="datatable_title">College Table</h1>
      <div className="d-flex justify-content-end">
        <Link
          to="/admin/admin-collegelistinfo-edit/Add"
          className="btn btn-dark btn-dark-1"
        >
          Create New College
        </Link>
      </div>
      <AdminCollegeDatatable data={collegelistinfo} loading={loading} setRefreshData={setRefreshData} refreshData={refreshData} />
      <div className="college_list_update_btn_div">
        <button className="college_list_update_btn">UPDATE</button>
      </div>
    </div>
  );
}

export default AdminCollegeList;
